import FormControls from 'component/FormControls';
import Modal from 'component/Modal';
import Page from 'component/Page';
import Table from 'component/Table';
import { Button } from 'react-bootstrap';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectSearchRangeDate } from 'redux/app/app.selector';
import { selectCurrentUser } from 'redux/user/user.selector';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import {
  adjustDate,
  formatDate,
  truncTime,
  setHours,
  emailValidate,
  nNU,
} from 'util/utils';
import SelectedNotifyMail from './SelectedNotifyMail';
import { validate } from 'uuid';
import { useMemo } from 'react';

const NotifyHistory = () => {
  const currentUser = useSelector(selectCurrentUser);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const searchRangeDate = useSelector(selectSearchRangeDate);
  const [mailAlertData, setMailAlertData] = useState(null);
  const [addr, setAddr] = useState(null);
  const history = useHistory();
  const infoAction = ({ raw }) => setMailAlertData(raw);
  const [searchId, setSearchId] = useState('');
  const [data, setData] = useState([]);
  const [debouncedSearchId, setDebouncedSearchId] = useState(searchId);
  const isMonitorOnly = useMemo(
    () => currentUser.isMonitorOnly === 1,
    [ currentUser.isMonitorOnly ]
  );

  const [searchData, setSearchData] = useState({
    fromDate: searchRangeDate?.[0] || truncTime(adjustDate(new Date(), -7)),
    toDate: searchRangeDate?.[1] || truncTime(),
  });
  const formControls = [
    {
      type: 'rangeDate',
      title: string.LOG_TIME,
      onChange: (e) =>
        setSearchData({
          ...searchData,
          fromDate: e[0],
          toDate: e[1],
        }),
      options: {
        defaultDate: [searchData.fromDate, searchData.toDate],
      },
    },
  ];
  const title = string.DEVICE_ALERT_HISTORY;
  const headers = [
    string.PROCESSED_TIME,
    '宛先',
    '件名',
    // string.PROCESSED_RESULT,
    // string.DEVICE_NAME,
    // string.DEVICE_ALERT_DETAIL,
    // string.DEVICE_ALERT_DETECTION_TIME,
    // string.DEVICE_ALERT_RESOLUTION_TIME,
    // string.DEVICE_ALERT_DETECTION_PERIOD,
  ];
  const csvHeaders = [
    string.DEVICE_SIGFOX_ID,
    string.DEVICE_NAME,
    string.DEVICE_ALERT_DETAIL,
    string.DEVICE_ALERT_DETECTION_TIME,
    string.DEVICE_ALERT_DETECTION_LAT,
    string.DEVICE_ALERT_DETECTION_LONG,
    string.DEVICE_ALERT_DETECTION_DEVICE_URL,
    string.DEVICE_ALERT_DETECTION_MAP_URL,
    // string.DEVICE_ALERT_RESOLUTION_TIME,
    // string.DEVICE_ALERT_DETECTION_PERIOD,
  ];

  // eslint-disable-next-line no-unused-vars

  const modalMailBody = (
    <>
      <Page
        title={string.MAIL_DETAIL}
        body={
          <>
            <SelectedNotifyMail selectedData={mailAlertData} />
          </>
        }
      />
    </>
  );
  const modalAddrBody = (
    <>
      <div>
        {!!nNU(addr)
          ? addr.map((mail) =>
              emailValidate(mail) ? <div>{`${mail}`}</div> : ''
            )
          : ''}
      </div>
    </>
  );

  const handleAddrButtonClick = (e) => {
    let id = e.currentTarget.id;
    const list = id.split(',');
    setAddr(list);
  };
  const getFirstEmail = (emails, index) => {
    if (!!nNU(emails)) {
      const emailArray = emails.split(',');
      if (emailArray.length > 1) {
        // return emailArray[0];
        return (
          <>
            <Button
              id={`${index},${emails}`}
              onClick={(e) => handleAddrButtonClick(e)}
            >
              {`${emailArray[0]} •••`}
            </Button>
          </>
        );
      } else {
        return emails;
      }
    } else {
      return '';
    }
  };
  const dataTable = useCallback(
    (data) =>
      data.map((raw, key) => ({
        key,
        data: [
          formatDate(raw?.processedDate, 'YYYY-MM-DD HH:mm:ss'),
          !nNU(raw?.sendTo) ? '' : getFirstEmail(raw?.sendTo, key),
          !nNU(raw?.subject) ? '' : raw?.subject,
          // raw.status,
        ],
        raw,
      })),
    []
  );
  // console.log(data);
  const actions = [
    // { render: 'info', onClick: infoAction },
    ({ raw }) => {
      if (!!nNU(raw.text)) {
        return { render: 'mail', onClick: infoAction };
      }
    },
  ];
  const doSearch = useCallback(
    async (page, pageSize, searchId, getAll = false) => {
      setHours(searchData.fromDate);
      setHours(searchData.toDate, 23, 59, 59, 999);

      let body = {
        ...(!searchData?.fromDate
          ? null
          : {
              startProcessedDate: searchData.fromDate.toISOString(),
            }),
        ...(!searchData?.toDate
          ? null
          : {
              endProcessedDate: searchData.toDate.toISOString(),
            }),
        ...(!nNU(searchId) || searchId.length === 0
          ? null
          : {
              email: searchId,
            }),
        // email: currentUser.email,
        // detectionTime: new Date(),
        offset: (page - 1) * pageSize,
        size: pageSize,
      };
      console.log(body?.email);
      if (!body?.startProcessedDate || !body?.endProcessedDate) {
        return;
      }
      let data = await sendPost({
        url: Urls.account.maillog,
        body,
      });
      const { total, result } = data;
      if (!getAll) {
        setData(result);
        setTotal(total);
      }
      return result;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchData]
  );

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchId(searchId);
    }, 500);

    return () => {
      clearTimeout(timerId);
    };
  }, [searchId]);

  useEffect(() => {
    doSearch(page, pageSize, debouncedSearchId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, pageSize, debouncedSearchId, doSearch]);

  return (
    <>
      <Page
        title={<>{title}</>}
        body={
          <>
            <FormControls controls={formControls} />
            <Table
              className="nowrap"
              page={page}
              actions={actions}
              pageSize={pageSize}
              total={total}
              onPageChanged={setPage}
              onPageSizeChanged={setPageSize}
              headers={headers}
              // csvHeaders={csvHeaders}
              data={dataTable(data)}
              getCSVData={!isMonitorOnly && (async () => {
                return dataTable(await doSearch(1, total, '', true));
              })}
              csvFileName="NotifyHistory"
              search={true}
              onSearch={(value) => setSearchId(value)}
              placeHolder={`${string.EMAIL_ADDRESS}`}
            />
          </>
        }
      />
      <Modal
        show={!!mailAlertData}
        onHide={() => setMailAlertData(null)}
        body={modalMailBody}
      />
      <Modal show={!!addr} onHide={() => setAddr(null)} body={modalAddrBody} />
    </>
  );
};

export default NotifyHistory;
